
/*global */
import React, { Component } from 'react';
import Box from './Box'

class DocsDeveloperIntegrations extends Component {
    render() {
        return (
            <div style={{"maxWidth": "780px"}}>
                <p>Any test framework, including custom frameworks, are capable of submitting test results data to Tesults for analysis, reporting and monitoring. Tesults provides libraries to achieve this for popular programming languages including Java, Python, C#, JS/Node.js, Ruby and Go. See 'Integration' and 'Language APIs' on the side menu.</p>
                <p>To make integrating with Tesults faster and easier for engineering teams, Tesults also provides integrations for popular test frameworks that are built on top of the language libraries. See 'Integrations' and 'Test Frameworks' on the side menu.</p>
                <Box
                    bg="primary8bg"
                    content={
                        <div>
                            <p>We are always looking to expand the number of test framework libraries we provide as well as update and maintain existing libraries.</p>
                            <p>We are looking for developers to create and enhance test framework libraries.</p>  
                        </div>
                    }
                />
                <p>Standard requirements of a test framework integration:</p>
                <ul>
                    <li>Be built using one of the language libraries, with the main job of the test framework library being to map test output from the test framework to the data format required by the Tesults language library.</li>
                    <li>Automatically submit test results data to Tesults at the end of a test run. This includes all test cases run, including details about each test case (specifically, suite, result, any test generated files such as screenshots, logs and custom files, steps, start and end times and duration, failure reason, parameters, custom fields) as well as the ability to provide optional basic build information.</li>
                    <li>Accept and pass through standard parameters:
                        <ul>
                            <li>Target token. Target tokens map to a specific test job ‘bucket’ on Tesults, see https://www.tesults.com/docs/target for more information. Target tokens can be generated from the Configuration menu in the Tesults interface or by utilizing the Tesults API. A target token is generated for the default target on the creation of a new Tesults project.</li>
                            <li>Build information. Including name, description, result and files.</li>
                        </ul>
                    </li>
                    <li>Committed to a Tesults test framework integration repository (specified by Tesults) and be made available with MIT license.</li>
                </ul>
            </div>
        );
    }
}

export default DocsDeveloperIntegrations